if (!customElements.get('shop-by-category')) {
  class ShopByCategory extends HTMLElement {
    constructor() {
      super();
      this.currentToggle = this.querySelector('[data-action="toggle-images"]:checked')?.value;
    }
    
    connectedCallback() {
      if (!this.currentToggle) return;
      
      this.addEventListener('change', e => {
        const toggle = e.target.value;
        if (!toggle || !e.target.closest('[data-action="toggle-images"]')) return;
        
        this.currentToggle = toggle;
        this.toggleImages();
      });
      
      if (document.readyState === 'complete') {
        setTimeout(() => {
          this.toggleImages();
        }, 10);
        return;
      }
      
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(() => {
          this.toggleImages();
        }, 10);
      });
    }
    
    toggleImages(toggle = this.currentToggle) {
      if (!toggle) return;
      this.querySelectorAll('[data-toggle-value]').forEach((el) => {        
        if (el.dataset.toggleValue === toggle) {
          el.style.display = null;
          return;
        }
        
        el.style.display = 'none';
      });
      
      setTimeout(() => { this.querySelector('swiper-carousel')?.slider?.update(); }, 10)
    }
  }
  
  customElements.define('shop-by-category', ShopByCategory);
}
